/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import BraindateCardGroupAvatarQueue from 'src/shared/ui/component/image/BraindateCardGroupAvatarQueue';
import { getConversationParticipants } from '@e180/domain/lib/conversation/util';

import type { AvatarProps } from 'src/shared/ui/component/image/type/avatarTypes';

type Props = AvatarProps & {
  conversation: boolean,
  spots: Number,
};

const BraindateCardGroupAvatar = ({
  conversation,
  layoutClass,
  variant,
  alt,
  spots,
}: Props): React.Node => (
  <BraindateCardGroupAvatarQueue
    layoutClass={layoutClass}
    variant={variant}
    alt={alt}
    spots={spots}
    participants={getConversationParticipants(conversation)}
  />
);

export default compose(React.memo)(BraindateCardGroupAvatar);
